<template>
  <div>
    <van-nav-bar
      title="我的现金券"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/member/members')"
    />
    <div style="">
      <van-empty image="error" description="暂无我的现金券" v-if="isCoupon" />
      <div class="coupon-wrap">
        <van-loading
          v-if="isLoading"
          style="text-align: center; padding-top: 20px"
          >加载中...</van-loading
        >
        <div
          class="coupon-box"
          v-for="(item, index) in couponList"
          :key="index"
        >
          <p>现金券: 充值满{{ item.amount * 10 }}送{{ item.amount }}港元</p>
          <van-row>
            <van-col span="16">有效期: {{ item.effect_date }}</van-col>
            <van-col span="8"
              ><van-button
                type="danger"
                round
                size="mini"
                style="float: right"
                @click="goPage"
                >去使用</van-button
              ></van-col
            >
          </van-row>
          <p>要求 配资后买入额达到{{ item.amount * 10.1 }}港元后可提现</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserCoupon",
  data() {
    return {
      couponList: [],
      isCoupon: false,
      isLoading: false,
    };
  },
  methods: {
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    myCoupon() {
      let that = this;
      that.isLoading = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "my_coupon",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          that.isLoading = false;
          let resData = res.data;
          if (res.data.code === 1) {
            that.couponList = res.data.data;
            if (that.couponList.length < 1) {
              that.isCoupon = true;
            }
          } else {
            that.$toast.fail(resData.msg);
          }
        })
        .catch(() => {
          that.isLoading = false;
        });
    },
    goPage() {
      this.$router.push({
        path: "/member/recharge",
      });
    },
  },
  mounted: function () {
    let that = this;
    that.isLogin();
    that.myCoupon();
  },
};
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.coupon-wrap {
  width: 100%;
  background: rgb(242, 242, 242);
}
.coupon-box {
  width: 90%;
  margin: 10px auto;
  font-size: 14px;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/UserCoupon.vue